import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioQuantitativoIntervaloAnoReducer(state = initialState.relatorioQuantitativoIntervaloAno, action){
    switch(action.type) {
        case types.RELAT_QUANTITATIVO_INTERVALO_ANO:
            
            return action.relatorioQuantitativoIntervaloAno;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioQuantitativoIntervaloAnoReducer.js
 **/